import * as yup from 'yup'

export const schemaTaxInvoiceYapay = yup.object().shape({
  daysToGenerateNFe: yup
    .number()
    .typeError('Preencha este campo')
    .moreThan(-1, 'Digite um número maior ou igual a zero')
    .lessThan(32, 'Digite um número menor ou igual a 31')
    .required(),
  simplesNacionalNFe: yup
    .number()
    .typeError('Informe um valor entre 0 e 100')
    .moreThan(-1, 'Digite um número maior ou igual a 0')
    .lessThan(32, 'Digite um número menor ou igual a 100'),
  ccm: yup.string().required(),
  password: yup.string().required(),
  serviceCode: yup.string().required(),
  situation: yup.string().required(),
  breakLine: yup.string().required(),
})

export default schemaTaxInvoiceYapay
